import React, { useContext } from 'react'
import { Button } from 'components/atoms'
import { TextContext } from 'hocs'
import PropTypes from 'prop-types'
import * as Styled from './HomeContract.styles'

const HomeContract = ({ content, link }) => {
  const textContext = useContext(TextContext)

  const handleButtonClick = () => {
    window.open(link, '_blank')
  }

  return (
    <>
      {content && <span dangerouslySetInnerHTML={{ __html: content }} />}
      {link && (
        <Styled.ButtonWrapper container justifyContent='flex-end'>
          <Button
            id={ 'border-btn' }
            text={ textContext['homeContract.downloadButton'] }
            onClick={ handleButtonClick }
            className={ 'with-border btn-appointment' }
          />
        </Styled.ButtonWrapper>
      )}
    </>
  )
}

HomeContract.propTypes = {
  content: PropTypes.string,
  link: PropTypes.string,
}

export default HomeContract
